export default __webpack_public_path__ + "static/media/rejected-loan.a856404b.png";